module.exports = __webpack_public_path__ + "static/media/pt-share-image.663259b0.jpg";